export default __webpack_public_path__ + "locales/pt/Common.json?hash=a4912522e41d290e3f02e6ebfc52c96f";